import { BankAccountApi } from "@/api/BankAccountApi";
import { CreditOperatorApi } from "@/api/CreditOperatorApi";
import { EDITOR_INPUT, SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { CARD_PAYMENT_WAY_CODE, CHEQUE_PAYMENT_WAY_CODE, DIGITAL_PLATFORM_PAYMENT_WAY_CODE, SINPE_PAYMENT_WAY_CODE, TRANSFER_PAYMENT_WAY_CODE } from "@utils/Constants";
import { generatePaymentMethodOptions } from "@utils/Utils";

const CancelInvoiceFormConfig = {
    submit: {
        label: "Crear Recibo"
    },
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "hidden",
                        "name": "currencyId",
                    },
                    {
                        "type": "hidden",
                        "name": "exchange_rate",
                    },
                ],
                [
                    {
                        "type": "date",
                        "name": "created",
                        "label": "Fecha",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "total",
                        "isDecimal": true,
                        "step": "0.01",
                        "isHorizontal": true,
                        "min": "1",
                        "label": "Monto",
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 4
                        },
                    },
                ],
                [
                    {
                        "type": "number",
                        "name": "numero_recibo",
                        "label": "Numero Recibo",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "forma_pago",
                        "label": "Forma de Pago",
                        "options": generatePaymentMethodOptions([1, 2, 4, 5, 7]),
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "factura_abono",
                        "label": "Aplicar abono a factura",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 9
                        },
                    }
                ],
                [
                    {
                        "type": "number",
                        "name": "digitosTarjeta",
                        "label": "Ultimos 4 digitos",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "visibleIf": {
                            "forma_pago": `${CARD_PAYMENT_WAY_CODE}`
                        }
                    }
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "creditOperatorId",
                        "label": "Operador de Tarjeta",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "optionsFunction": () => CreditOperatorApi.optionsList(),
                        "visibleIf": {
                            "forma_pago": `${CARD_PAYMENT_WAY_CODE}`
                        }
                    }
                ],
                [
                    {
                        "type": "number",
                        "name": "numAprobacion",
                        "label": "Numero Aprobacion",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "visibleIf": {
                            "forma_pago": `${CARD_PAYMENT_WAY_CODE}`
                        }
                    }
                ],
                [
                    {
                        "type": "number",
                        "name": "reference",
                        "label": "Numero Referencia",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "visibleIf": {
                            "forma_pago": [
                                `${CHEQUE_PAYMENT_WAY_CODE}`,
                                `${TRANSFER_PAYMENT_WAY_CODE}`,
                                `${SINPE_PAYMENT_WAY_CODE}`,
                                `${DIGITAL_PLATFORM_PAYMENT_WAY_CODE}`,
                            ]
                        }
                    }
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "bankAccountId",
                        "label": "Cuenta Bancaria",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 9
                        },
                        "visibleIf": {
                            "forma_pago": [
                                `${CHEQUE_PAYMENT_WAY_CODE}`,
                                `${TRANSFER_PAYMENT_WAY_CODE}`,
                                `${SINPE_PAYMENT_WAY_CODE}`,
                                `${DIGITAL_PLATFORM_PAYMENT_WAY_CODE}`,
                            ]
                        },
                        "optionsFunction": () => BankAccountApi.optionsList(),
                    }
                ],
                [
                    {
                        "type": EDITOR_INPUT,
                        "name": "comments",
                        "label": "commentarios",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 9
                        }
                    }
                ],
            ]
        }
    ],
};


export default CancelInvoiceFormConfig;